export default __webpack_public_path__ + "static/media/920.fdde3306.jpg";